import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from '/webresources-sources/js/util/jquery';

export default class MapComponent extends BaseComponent {
    properties() {
        return {};
    }

    events() {
        return {
            this: {
                'filter-change': (e) => {
                    const mapElement = this.element.querySelector('[data-component="map-element"]');
                    mapElement.filter = e.detail;
                },
            },
        };
    }
}

defineComponent('map-component', MapComponent);
